import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Store } from '@ngrx/store';
import { UserInfo } from '../../../interfaces';
import { AppFields, Observable, filter, map, take, AppTypes, combineLatest, StorageUtil } from '../../../store';

@Component({
  selector: 'app-tryout-page-header',
  templateUrl: './tryout-page-header.component.html',
  styleUrls: ['./tryout-page-header.component.css']
})

export class TryoutPageHeaderComponent implements OnInit {
  @Output() deleteProgramsEvent = new EventEmitter();
  @Output() deleteMembersEvent = new EventEmitter();
  @Output() deleteFeesEvent = new EventEmitter();
  @Output() deleteQuestionsEvent = new EventEmitter();
  @Output() newQuestionsEvent = new EventEmitter();
  @Output() filterProgramsEvent = new EventEmitter();
  @Output() changeProgramStatusEvent = new EventEmitter();
  @Output() memberSearchEvent = new EventEmitter();
  @Output() deleteDiscountEvent = new EventEmitter();
  @Output() deleteFormEvent = new EventEmitter();
  @Output() openDiscountEvent = new EventEmitter();
  @Output() openFinancialEvent = new EventEmitter();
  @Output() openExportEvent = new EventEmitter();
  @Output() openFormEvent = new EventEmitter();
  @Output() newMemberEvent = new EventEmitter();
  @Output() inviteMemberEvent = new EventEmitter();
  @Output() reinviteMemberEvent = new EventEmitter();
  @Output() exportMemberEvent = new EventEmitter();
  @Output() assignMemberEvent = new EventEmitter();
  @Output() mailToEvent = new EventEmitter();
  @Output() changePlayerStatusEvent = new EventEmitter();

  @Input() PageHeaderName: string;
  @Input() NoOfSelectedProgram: number;
  @Input() NoOfSelectedMember: number;
  @Input() NoOfSelectedFees: number;
  @Input() NoOfSelectedQuestion: number;
  @Input() NoOfSelectedDiscount: number;
  @Input() NoOfSelectedForm: number;
  @Input() NoOfAllMembers: number;

  public subscription: Subscription;
  public currentUrl = '';
  public routeParams;
  public program_status = '';
  public programStatusForm: FormGroup;

  user: Observable<UserInfo>;
  programFees: Observable<any>;
  isShowInvite: Observable<boolean>;
  isTeam: Observable<boolean>;

  constructor(
    private fb: FormBuilder,
    private activeRoute: ActivatedRoute,
    public router: Router,
    private store: Store<any>
  ) {
    this.user = this.store.select(AppFields.App, AppFields.User);

    this.programFees = this.store.select(AppFields.App, AppFields.ClubProgramFees);
    this.isShowInvite = this.programFees.pipe(
      filter(p => p !== null),
      map(res => res.programs && res.programs.length)
    );
    this.isTeam = this.store.select(AppFields.App, AppFields.TeamAccount).pipe(filter(p => p !== null));
  }

  ngOnInit() {
    this.currentUrl = this.router.url;
    this.routeParams = this.activeRoute.snapshot.params;

    this.store.dispatch({
      type: AppTypes.GetClubProgramFees,
      payload: {
        clubId: StorageUtil.clubID,
        teamId: StorageUtil.teamId || 0
      }
    });

    this.getPageHeaderName();

    if (this.routeParams.status) {
      let statusDropDown = '';
      if (this.routeParams.status === 'inactive') {
        statusDropDown = '0';
      } else if (this.routeParams.status === 'active') {
        statusDropDown = '1';
      } else if (this.routeParams.status === 'archive') {
        statusDropDown = '2';
      }
      this.programStatusForm = this.fb.group({
        program_status: [statusDropDown, [Validators.required]],
      });
    }
  }

  checkIsTryoutMembers() {
    return this.router.url.includes('/tryoutmembers/');
  }

  getPageHeaderName() {
    /* TODO: Implement this code after remove header & breadcrumb component from all page. Left Nav Properties. */
    // this.subscription = this.leftNavigationService.getLeftNav().subscribe((navObject: any) => {
    //  console.log("navObject in page-header:",navObject);
    //  console.log("navObject.ProgramName in page-header:", navObject.ProgramName);
    //  //if (navObject.ProgramName !== 'undefined') {
    //  //  this.PageHeaderName = navObject.ProgramName;
    //  //} else {
    //  //  this.PageHeaderName = '';
    //  //}
    // });

    const retrievedObject = localStorage.getItem('routeObject');

    const p = JSON.parse(retrievedObject);
    if (p && p.ClubProgramName !== '') {
      if (p.ClubProgramTypeID === 1) {
        this.PageHeaderName = 'Club Billing - ' + p.ClubProgramName;
      } else if (p.ClubProgramTypeID === 2) {
        this.PageHeaderName = 'Tryout - ' + p.ClubProgramName;
      } else if (p.ClubProgramTypeID === 3) {
        this.PageHeaderName = 'Team Travel - ' + p.ClubProgramName;
      } else if (p.ClubProgramTypeID === 4) {
        this.PageHeaderName = 'Camps / Clinics - ' + p.ClubProgramName;
      } else if (p.ClubProgramTypeID === 5) {
        this.PageHeaderName = 'Fundraising - ' + p.ClubProgramName;
      } else if (p.ClubProgramTypeID === 6) {
        this.PageHeaderName = 'All In Program - ' + p.ClubProgramName;
      } else {
        this.PageHeaderName = '';
      }
    } else {
      this.PageHeaderName = '';
    }
  }

  /* Go to create a new program page. */
  newProgram() {
    this.router.navigate(['tryoutprogram/tryout/add']);
  }

  /* Go to edit a program page. */
  // editProgram() {
  //  this.router.navigate(['club/edit']);
  // }

  /* Go to list of programs page. */
  backProgram() {
    this.router.navigate(['tryoutprogram/active']);
  }

  /* Go to create a new fee page. */
  newFee() {
    const RP = this.routeParams;
    this.router.navigate([
      '/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step1'
    ]);
  }

  backToFees(programName, clubProgramID, programStatus) {
    this.router.navigate([
      'tryoutprogram/' + programName + '/' + clubProgramID + '/' + programStatus + '/fee'
    ]);
  }

  backToMembers(programName, clubProgramID, programStatus) {
    this.router.navigate([
      'tryoutmembers/' + programName + '/' + clubProgramID + '/' + programStatus
    ]);
  }

  deleteSelectedProgramRecords() {
    this.deleteProgramsEvent.emit('test');
  }

  deleteSelectedMemberRecords() {
    this.deleteMembersEvent.emit('test');
  }

  deleteSelectedFeeRecords() {
    this.deleteFeesEvent.emit('test');
  }

  deleteSelectedDiscount() {
    this.deleteDiscountEvent.emit('test');
  }

  deleteSelectedForm() {
    this.deleteFormEvent.emit('test');
  }

  filterProgramListing(obj) {
    this.program_status = obj;
    this.filterProgramsEvent.emit(this.program_status);
  }

  changeProgramStatus(obj) {
    this.changeProgramStatusEvent.emit(obj);
  }

  newDiscount(obj) {
    this.openDiscountEvent.emit(obj);
  }
  newPayment(obj) {
    this.openFinancialEvent.emit(obj);
  }
  exportTransectionFile(obj) {
    this.openExportEvent.emit(obj);
  }

  newForm(obj) {
    this.openFormEvent.emit(obj);
  }

  newMember(obj) {
    this.newMemberEvent.emit(obj);
  }

  inviteMember(obj) {
    this.inviteMemberEvent.emit(obj);
  }

  reinviteMember(obj) {
    this.reinviteMemberEvent.emit(obj);
  }

  assignMember() {
    this.assignMemberEvent.emit();
  }

  exportMember() {
    this.exportMemberEvent.emit();
  }

  //for TW TaskID - 28926597
  changePlayerStatus(obj) {
    this.changePlayerStatusEvent.emit(obj);
    if (+obj == 0) {
      this.assignMember();
    }
    if (+obj == 1) {
      this.inviteMember(obj);
    }
  }

  mailTo() {
    this.mailToEvent.emit();
  }

  isCurrentFeeFormPage() {
    const RP = this.routeParams;
    return this.router.url === '/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step1'
      || this.router.url === '/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step1/' + RP.feeId
      || this.router.url === '/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step2/' + RP.feeId
      || this.router.url === '/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step3/' + RP.feeId;
  }

  onMemberSearch() {
    this.memberSearchEvent.emit('test');
  }

  /* ============================= QUESTION =================================== */
  isQuestionListingPage() {
    const RP = this.routeParams;
    return this.router.url === '/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/question/' + RP.isRequired;
  }
  newQuestion() {
    this.newQuestionsEvent.emit('test');
  }
  deleteSelectedQuestions() {
    this.deleteQuestionsEvent.emit('test');
  }

  /* ============================= DISCOUNT =================================== */
  isDiscountPage() {
    const RP = this.routeParams;
    return this.router.url === '/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/discount';
  }

  get programEnabled(): Observable<boolean> {
    return combineLatest(
      this.store.select(AppFields.App, AppFields.TeamAccount),
      this.store.select(AppFields.App, AppFields.MyTeam),
      (isTeamAccount: boolean, isTeamBilling: boolean) => {
        return !isTeamBilling && !isTeamAccount && !!StorageUtil.clubID;
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/tryout-page-header/tryout-page-header.component.ts